export default __webpack_public_path__ + "static/media/sp_common.301bb457.png";